/**
 * Displays a bottom panel containing a paginated, sortable results table.
 *
 * The `BottomBar` component serves as a container for the `ResultsTable` UI.
 * It manages row selection state and relays selected rows back to parent
 * components through the `onRowSelect` callback.
 */

import React, { useState } from "react";
import ResultsTable, { ColumnDef } from "./ResultsTable";

type BottomBarProps = {
    slot?: string;
    style?: React.CSSProperties;
    rows: any[];
    columns: ColumnDef[];
    onRowSelect?: (row: any) => void;
    pageSizeOptions?: number[];
    defaultPageSize?: number;
    showColumnChooser?: boolean;
    activeServiceRoot?: string | null;
};

const BottomBar: React.FC<BottomBarProps> = ({
    slot,
    style,
    rows,
    columns,
    onRowSelect,
    pageSizeOptions,
    defaultPageSize,
    showColumnChooser = true,
    activeServiceRoot
}) => {
    const [selectedIndex, setSelectedIndex] = useState<number>(-1);
    const total = rows.length;

    return (
        <div
            slot={slot}
            className="bottom-panel"
            style={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", background: "#fff", ...style }}
        >
            <ResultsTable
                rows={rows}
                columns={columns}
                selectedIndex={selectedIndex}
                onRowClick={(idx: number) => {
                    setSelectedIndex(idx);
                    onRowSelect?.(rows[idx]);
                }}
                footer={{
                    rangeText: total ? `1 - ${Math.min(total, defaultPageSize ?? 5)} of ${total} results` : "0 results",
                    page: 1,
                    pageSize: defaultPageSize ?? 5
                }}
                defaultPageSize={defaultPageSize}
                pageSizeOptions={pageSizeOptions}
                showColumnChooser={showColumnChooser}
                activeServiceRoot={activeServiceRoot}
            />
        </div>
    );
};

export default BottomBar;
